import { NavLink } from 'react-router-dom'
import { TABS, type TabDescriptor } from './tabs'

const BASE_CLASSES = 'flex-1 py-3.5 text-center text-sm font-medium transition-colors'
const ACTIVE_CLASSES = 'text-twitter-blue'
const INACTIVE_CLASSES = 'text-white/70 hover:text-white'

/**
 * A tab still pointing at a backend-served page leaves the SPA, so it is a plain anchor and can
 * never report itself active — the app it would be active in is no longer running.
 */
function TabLink({ tab }: { tab: TabDescriptor }) {
  if (tab.external) {
    return (
      <a href={tab.to} className={`${BASE_CLASSES} ${INACTIVE_CLASSES}`}>
        {tab.label}
      </a>
    )
  }

  return (
    <NavLink
      to={tab.to}
      end
      className={({ isActive }) =>
        `${BASE_CLASSES} ${isActive ? ACTIVE_CLASSES : INACTIVE_CLASSES}`
      }
    >
      {tab.label}
    </NavLink>
  )
}

export function TabBar() {
  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 bg-white/10 backdrop-blur-md border-t border-white/10 pb-[env(safe-area-inset-bottom)]"
    >
      {/* The bar spans the viewport so its background reaches both edges, but the tabs themselves
          stay in a centred column. Without the cap they spread across a desktop viewport and land
          nowhere near each other, which reads as three unrelated links rather than one control. */}
      <div className="mx-auto flex w-full max-w-[480px]">
        {TABS.map((tab) => (
          <TabLink key={tab.id} tab={tab} />
        ))}
      </div>
    </nav>
  )
}
